import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Picker, QuickValue, TimePicker} from '../../interface/TimePicker';

@Component({
  selector: 'c-quick',
  templateUrl: './quick.component.html',
  styleUrls: ['./quick.component.scss']
})
export class QuickComponent implements OnInit {

  @Input() cTime: QuickValue;

  @Input() cTimePicker: TimePicker;

  @Output() cChangeTime: EventEmitter<Picker> = new EventEmitter<Picker>();

  constructor() {
  }

  ngOnInit() {
  }

  public selectTime(item) {
    this.cTime.step = item.step;
    this.cTime.particle = item.particle;
    this.cChangeTime.emit({
      title: item.title,
      value: this.cTime
    });
  }

}
